
export enum FloorplanEventTypes {
  BookingDragStartEvent = `FloorplanEvent-BookingDragStartEvent`,
  BookingDragEndEvent = `FloorplanEvent-BookingDragEndEvent`,
  BookingDragEvent = `FloorplanEvent-BookingDragEvent`,
  BookingDropEvent = `FloorplanEvent-BookingDropEvent`,
}

export interface IFloorplanDispatchEvent {
  eventType: FloorplanEventTypes;
  eventDetail?: {
    [key: string]: any;
  };
}

